import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCountryList,
  updateCountryList,
} from "../../../slices/LocationSlice/countrySlice";
import {
  fetchCityList,
  updateCityList,
} from "../../../slices/LocationSlice/citySlice";
import { fetchOptionListData } from "../../../slices/LocationSlice/optionSlice";
import Pagination from "../../../components/Pagination";
import Loader from "../../../components/Loader";
import EditableTable from "./CityTable";
import Modal from "../../../components/Modal";
import ChangeLog from "../../../components/ChangeLog";
import { fetchLanguageList } from "../../../slices/panelSlice/languageSlice";
import SearchTable from "@/components/SearchTable";
import AddCity from "./AddCity";


function City({editable}) {
  const dispatch = useDispatch();
  const { cityList, status, error } = useSelector((state) => state.city);
  const country = useSelector((state) => state.countryList);
  const { data } = useSelector((state) => state.language);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(cityList?.result)
    ? cityList?.result?.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = Array.isArray(cityList?.result)
    ? Math.ceil(cityList?.result?.length / itemsPerPage)
    : 0;
  const headers =
    cityList?.result?.length > 0
      ? Object.keys(cityList.result[0]).filter((key) => key !== "id")
      : [];
  const editableFields = ["title", "status", "code", "val", "optionType"]; // Define editable fields

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);
  const [addCountryModal, setAddCountryModal] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const { optionList } = useSelector((state) => state.option);

    const [searchQuery, setSearchQuery] = useState("")
    const [filteredRows, setFilteredRows] = useState(currentItems);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchCityList());
    }
    if (country.status === "idle") {
      dispatch(fetchCountryList());
    }
    dispatch(fetchLanguageList());
    dispatch(fetchOptionListData());
  }, [dispatch]);

  // if (status === "loading") {
  //   return <Loader></Loader>;
  // }

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = cityList.result.find((user) => user.id === rowId);
    setEditedData(rowData);
  };

  const handleSave = async () => {
    const { id, title, code, optionType, val, status } = editedData;
    const optionId = optionList?.result?.filter(
      (f) => f.title === optionType
    )[0]?.id;
    const updatedData = { id, title, code, optionType: optionId, val, status };
    
    const resp = await dispatch(updateCityList(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchCityList());
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field, val) => {
    if (["status", "active"].includes(field)) {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };

  const handleLog = (id) => {
    const logData = cityList.Change_Log.filter((f) => f.id === id)[0]
      ?.oldTrack;
    setCurrentLog(logData);
    openModal();
  };

  return (
    <div className="w-full flex items-center flex-col">
<div className="w-11/12 flex justify-end">
<SearchTable
            placeholder="Search for a tier..."
            data={currentItems}
            onSearchResults={setFilteredRows} // Update filtered list in parent
            className='m-2'
            allData={cityList?.result}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />
</div>


<div className="max-w-full overflow-scroll">

  {status === "loading" ? <div className="w-full h-[100px] overflow-hidden"><Loader /></div>  : <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields} // Pass editable fields
        optionList={optionList}
        languageList={data?.result}
        filteredRows={filteredRows}
        editable={editable}
/>}

</div>

    


      <div className="flex mt-4 items-center justify-between w-11/12">
      {searchQuery.length < 3 && <Pagination
  currentPage={currentPage}
  setCurrentPage={setCurrentPage}
  totalPages={totalPages}
/>}
        {editable && 
          <button
          className="activeBtn text-sm text-white  py-1 px-2 rounded"
          onClick={() => setAddCountryModal(true)}
        >
          + Add City
        </button>
        }
      
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog} />}
      />

      <Modal
        isOpen={addCountryModal}
        onClose={() => setAddCountryModal(false)}
        title="Add City"
        content={
          <AddCity optionList={optionList}/>
        }
      />
      
    </div>
  );
}

export default City;
